export default "__VITE_ASSET__16_m6sg___"